import type { Role } from "@/store/useDemoStore";

export interface FlowStep {
  step: number;
  path: string;
  label: string;
  role: Role;
}

export const FLOW: FlowStep[] = [
  { step: 1, path: "/admin", label: "Dashboard del administrador", role: "admin" },
  { step: 2, path: "/admin/estandares", label: "Catálogo de estándares", role: "admin" },
  { step: 3, path: "/admin/estandares/nuevo", label: "Crear nuevo estándar (lectura IA del PDF)", role: "admin" },
  { step: 4, path: "/admin/estandares/EC1781", label: "Configurar EC1781 — elementos sugeridos por IA", role: "admin" },
  { step: 5, path: "/admin/estandares/EC1781/elementos/elem-e5638/criterios", label: "Configurar criterios y evidencias", role: "admin" },
  { step: 6, path: "/admin/estandares/EC1781/elementos", label: "Construir instrumentos por elemento", role: "admin" },
  { step: 7, path: "/admin/estandares/EC1781/reglas", label: "Configurar reglas de dictaminación (7 familias)", role: "admin" },
  { step: 8, path: "/admin/estandares/EC1781/publicar", label: "Revisar y publicar el estándar", role: "admin" },
  { step: 9, path: "/admin/grupos", label: "Abrir generación y grupos", role: "admin" },
  { step: 10, path: "/admin/grupos/grp-2026-1", label: "Inscribir candidatos al grupo 2026-A", role: "admin" },
  { step: 11, path: "/alumno", label: "El candidato accede a su tablero", role: "alumno" },
  { step: 12, path: "/alumno/diagnostico", label: "Aplicar evaluación diagnóstica", role: "alumno" },
  { step: 13, path: "/alumno/examen-teorico", label: "Aplicar examen teórico", role: "alumno" },
  { step: 14, path: "/alumno/expediente", label: "El candidato revisa su expediente", role: "alumno" },
  { step: 15, path: "/evaluador", label: "El evaluador abre su agenda", role: "evaluador" },
  { step: 16, path: "/evaluador/evaluacion/exp-001/prechecklist", label: "Lista preoperativa de la motocicleta", role: "evaluador" },
  { step: 17, path: "/evaluador/evaluacion/exp-001", label: "Aplicar evaluación práctica en circuito", role: "evaluador" },
  { step: 18, path: "/dictaminador", label: "El dictaminador abre su bandeja", role: "dictaminador" },
  { step: 19, path: "/dictaminador/expediente/exp-001", label: "Revisar expediente y confirmar pre-dictamen IA", role: "dictaminador" },
  { step: 20, path: "/dictaminador/certificado/exp-001", label: "Certificado emitido", role: "dictaminador" },
  { step: 21, path: "/auditor", label: "El auditor revisa la integridad del proceso", role: "auditor" },
];

export function nextStepFor(currentPath: string): FlowStep | null {
  const i = FLOW.findIndex((s) => s.path === currentPath);
  if (i === -1 || i === FLOW.length - 1) return null;
  return FLOW[i + 1];
}

export function currentStepFor(currentPath: string): FlowStep | null {
  return FLOW.find((s) => s.path === currentPath) ?? null;
}

export function prevStepFor(currentPath: string): FlowStep | null {
  const i = FLOW.findIndex((s) => s.path === currentPath);
  if (i <= 0) return null;
  return FLOW[i - 1];
}
